<template>
  <div
    class="flex items-align-center p-2"
    v-for="contato in contatos"
    :key="contato"
  >
    <a :href="contato.link" target="_blank">
      <svg-icon
        class="bg-[#f8f7f2] rounded"
        type="mdi"
        :path="contato.path"
      ></svg-icon>
    </a>
  </div>
</template>

<script>
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiEmail, mdiLinkedin, mdiGithub } from "@mdi/js";

export default {
  components: {
    SvgIcon,
  },
  data() {
    return {
      contatos: [
        {
          path: mdiLinkedin,
          link: "https://www.linkedin.com/in/gustavokubiack/",
        },
        {
          path: mdiEmail,
          link: "mailto:guukubiack@gmail.com",
        },
        {
          path: mdiGithub,
          link: "https://github.com/gustavokubiack",
        },
      ],
    };
  },
};
</script>